export const createBrowserPhoneCdr = async (cdr, accountId = null) => {
  const payload = { cdr };
  if (accountId) {
    payload.account_id = accountId;
  }

  const response = await window.axios.post('/api/v1/phone_cdrs', payload);
  return response.data;
};

export const uploadBrowserPhoneRecording = async ({
  accountId = null,
  file,
  filename,
  phoneCdrId,
  recordingUid,
}) => {
  const formData = new FormData();
  formData.append('file', file, filename);
  formData.append('recording_uid', recordingUid);

  if (accountId) {
    formData.append('account_id', String(accountId));
  }

  const response = await window.axios.post(
    `/api/v1/phone_cdrs/${phoneCdrId}/upload_recording`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return response.data;
};
